/* eslint-disable */
import { node } from "~/util/dom";
import { BRIEFCASE_OUTLINE_24, HOME_OUTLINE_24 } from "@sznds/icons";
import createSDSIcon from "~/ui/icon";
import Scene from "~/scene";

interface ICallbacks {
	clickCb?: (type: string) => void,
	enterCb?: () => void,
	leaveCb?: () => void,
}

export function createMarker(type: string, coords:{ lon: number, lat: number }, callbacks?: ICallbacks): any {
	const iconCover = node("span", { className: "mymap-svg-layer" });
	iconCover.appendChild(createSDSIcon({
		symbol: type === "home" ? HOME_OUTLINE_24 : BRIEFCASE_OUTLINE_24,
	}));

	let opts = {
		type: Scene.VISUAL.MARKER_WINDY.SMALL,
		elm: iconCover,
		m3dData: {
			type: "places",
			svg: type,
			click: () => {
				callbacks.clickCb && callbacks.clickCb(type);
			},
			enter: () => {
				callbacks.enterCb && callbacks.enterCb();
			},
			leave: () => {
				callbacks.leaveCb && callbacks.leaveCb();
			},
		}
	};
	const marker = Scene.createMarkerMapyWindy(Scene.coordsFromWGS84(coords.lon, coords.lat), null, opts);
	marker.setStyle("cursor", "pointer");
	marker.addEventListener("mouseenter", () => {
		callbacks.enterCb && callbacks.enterCb();
	});
	marker.addEventListener("mouseleave", () => {
		callbacks.leaveCb && callbacks.leaveCb();
	});
	marker.addEventListener("click", () => {
		callbacks.clickCb && callbacks.clickCb(type);
	});

	return marker;
}
